import React, { useState, useEffect } from "react";
import { API_URL } from "../../../../constants/index";


import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";


function Feedbackmaster() {
  const [feedbacksetfeedback, setfeedback] = useState([]);  
  const [searchTerm, setSearchTerm] = useState("");
  const [apiStatus, setApiStatus] = useState(undefined);
  const navigate = useNavigate();

  const columns = {
    Code: { text: "Code", visible: true  },
    Name: { text: "Name", visible: true  },
    Description: { text: "Description", visible: true  },
    ShowSuitablePosition: { text: "Suitable Position for Field",width:"100px", align:'center', visible: true },
    Categories: { text: "Categories", visible: true  },
    CreatedByName:{text: "CreatedBy", visible: true },
  };
  const defaultColumns = {
    Code: true,
    Name: true,
    Description: true,
    ShowSuitablePosition: true,
    Categories: true,
    CreatedByName:true
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Feedback Master"))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    fetchfeedbacksetfeedback();
  }, []);

  const fetchfeedbacksetfeedback = async () => {
    setApiStatus(undefined);
    try {
      const response = await GetServiceCaller(`${API_URL}feedback-master`);      
      setApiStatus(response.status);
      if (response.status === 200) {
        const cleanedData = response?.data?.data?.headers;
        setfeedback(cleanedData);
      } else {
        console.error(
          "Failed to fetch Course. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      setApiStatus(500);
      console.error("Error fetching Course:", error);
    }
  };

  const  handleAddForm = () =>{
    navigate('/feedback-master/add');
  }

  const handleEdit = (id) =>{
    navigate(`/feedback-master/edit/${id.ID}`);
  }

  return (
    <>
        <div className="container-fluid" id="skill_section">
          <div className="container-fluid" id="skill-table-area">
            <div className="row">
                 {/* eslint-disable-next-line react/jsx-pascal-case */ }
                <Dynamic_PR_table
                  data={feedbacksetfeedback}
                  columns={columns}
                  defaultColumns={defaultColumns}
                  itemsPerPage={8}
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                  isSorting={true}
                  isActionRequired={true}
                  isRequiredStatus={true}
                  isApiStatus={apiStatus}
                  showIcon1={true}
                  isAddNewBtnRequired={true}
                  handleAddNew={handleAddForm}
                  handleIcon1={handleEdit}
                  icons={{
                    Icon1: <i className="bi bi-pencil-square icons"></i>,
                  }}
                />
            </div>
          </div>
        </div>

    </>
  );
}

export default Feedbackmaster;



